import { Elm } from './Main.elm'
const WindowPort = require('./Ports/window.js');
const AmplitudePort = require('./Ports/amplitude.js')
const FullstoryPort = require('./Ports/fullstory.js')
const SmartlookPort = require('./Ports/smartlook.js')
const GooglePlacesPort = require('./Ports/google-places.js')
const GoogleRecaptchaPort = require('./Ports/google-recaptcha.js')
// const GoogleAnalyticsPort = require('./Ports/google-analytics.js')
const LocalStorage = require('./Ports/local-storage.js')
const NavigationPort = require('./Ports/navigation.js')
const NewRelic = require('./scripts/new-relic.js')
const PlaidPort = require('./Ports/plaid.js')
const SentryPort = require('./Ports/sentry.js')
const StripePort = require('./Ports/stripe.js')
const ThemePort = require('./Ports/theme.js')
const Statuspage = require('./scripts/statuspage.js')
const CustomJavascriptPort = require('./Ports/custom-javascript.js')
const PageTitlePort = require('./Ports/page-title.js')
const OnBeforeUnloadPort = require('./Ports/onBeforeUnload.js')
const OnElementScrollPort = require('./Ports/onElementScroll.js')
const OnTabSelectPort = require('./Ports/onTabSelect.js')

if (window.Sentry) {
  Sentry.init({
    dsn: CONFIGURATION.sentryDsn,
    environment: CONFIGURATION.sentryEnvironment,
    release: CONFIGURATION.sentryReleaseVersion,
    maxValueLength: 1000,
    ignoreErrors: [
      "Cannot resolve iframe with unknown index"
    ],
    denyUrls: [
      /extensions\//i,
      /smartlook\.cloud/i,
    ]
  });
}

// Initial data passed to Elm (should match `Flags` defined in `Shared.elm`)
// https://guide.elm-lang.org/interop/flags.html
var flags = {
  locationHref: location.href,
  accountToken: LocalStorage.getItem('accountToken'),
  accountPracticeId: LocalStorage.getItem('accountPracticeId')
}

// Start our Elm application
const app = Elm.Main.init({
  node: document.getElementById('elm-main'),
  flags: flags,
});

// Ports go here
// https://guide.elm-lang.org/interop/ports.html
if (CONFIGURATION.amplitudeApiKey) {
  AmplitudePort.add(app, CONFIGURATION.amplitudeApiKey)
};

WindowPort.add(app)
FullstoryPort.add(app, '38DP8', false)
if (CONFIGURATION.smartlookProjectKey) {
  SmartlookPort.add(app, CONFIGURATION.smartlookProjectKey)
};
GooglePlacesPort.add(app)
GoogleRecaptchaPort.add(app)
// GoogleAnalyticsPort.add(app);
LocalStorage.add(app);
NavigationPort.add(app);
PlaidPort.add(app, CONFIGURATION.plaidEnv, CONFIGURATION.plaidKey)
SentryPort.add(app, CONFIGURATION.env)
StripePort.add(app, CONFIGURATION.stripePublishableKey)
ThemePort.add(app)
CustomJavascriptPort.add(app)
PageTitlePort.add(app)
OnBeforeUnloadPort.add(app)
OnElementScrollPort.add(app)
OnTabSelectPort.add(app)

if (CONFIGURATION.statuspageEmbedCode) {
  Statuspage.setup(CONFIGURATION.statuspageEmbedCode);
};

if (CONFIGURATION.newRelicLicenseKey && CONFIGURATION.newRelicApplicationId) {
  NewRelic.setup(CONFIGURATION.newRelicLicenseKey, CONFIGURATION.newRelicApplicationId);
};

// detect if device is an iOS device and disable auto-zoom when clicking into elements
// https://stackoverflow.com/a/57527009

if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  const el = document.querySelector('meta[name=viewport]');

  if (el !== null) {
    let content = el.getAttribute('content');
    let re = /maximum\-scale=[0-9\.]+/g;

    if (re.test(content)) {
        content = content.replace(re, 'maximum-scale=1.0');
    } else {
        content = [content, 'maximum-scale=1.0'].join(', ')
    }

    el.setAttribute('content', content);
  }
}
